import Fuse from 'fuse.js'
import { debounce } from 'lodash'
import React, { useEffect, useCallback, memo, useState } from 'react'
import { Input, Box } from '@mui/material'

const FormSearchUserComponent = ({ setSearchArr, userArray }) => {
  const [searchText, setSearchText] = useState('')

  const searchFunction = useCallback(
    debounce((text) => {
      const list = userArray ?? []

      if (!text) {
        setSearchArr && setSearchArr([])
        return
      }

      const itemFuse = new Fuse(list, {
        shouldSort: true,
        includeScore: true,
        threshold: 0.3,
        ignoreLocation: true,
        keys: ['employeeId', 'name'],
      })

      const filtereditemFuse = itemFuse.search(text)

      const items = filtereditemFuse
        .filter((fuse) => fuse.score < 0.5)
        .map((each) => each.item)
        .sort((a, b) => b.totalPoint - a.totalPoint)

      setSearchArr && setSearchArr([...items])
    }, 500),
    [userArray]
  )

  /**
   * search function
   */
  useEffect(() => {
    searchFunction(searchText)
  }, [searchText])

  const handleOnChange = (e) => {
    setSearchText(e?.target?.value)
  }

  return (
    <Box hidden>
      <Input
        onChange={handleOnChange}
        value={searchText}
        label='Search'
        placeholder='Search...'
        name='search'
        type='search'
        id='user-search-input'
      />
    </Box>
  )
}

export const FormSearchUser = memo(FormSearchUserComponent)
